export const LoadingText = ({ classNames, text }: { classNames?: string; text?: string }) => {
  return (
    <div className={classNames} data-testid="loading-text">
      {text ? text : "Loading"}
      <span className="animate-[pulse_1s_infinite_100ms]">.</span>
      <span className="animate-[pulse_1s_infinite_300ms]">.</span>
      <span className="animate-[pulse_1s_infinite_500ms]">.</span>
    </div>
  );
};
